import { render, staticRenderFns } from "./edit-v2.vue?vue&type=template&id=41305052&"
import script from "./edit-v2.vue?vue&type=script&lang=js&"
export * from "./edit-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports